// 文件下载函数（对象参数版）
function fileDownload({
    filename,
    url,
    param = "",
    method = "GET",
    isContentType = false,
    setLoading = null
  }) {
    var oReq = new XMLHttpRequest();
    oReq.open(method, url, true);
  
    if (typeof setLoading === "function") {
      setLoading(true);
    }
  
    // 是否需要设置 Content-type
    if (isContentType) {
      oReq.setRequestHeader("Content-type", "application/json; charset=utf-8");
    }
  
    oReq.responseType = "blob";
  
    oReq.onload = function () {
      if (typeof setLoading === "function") {
        setLoading(false);
      }
  
      if (oReq.status === 200) {
        var content = oReq.response;
        var elink = document.createElement("a");
        elink.download = filename;
        elink.style.display = "none";
        var blob = new Blob([content]);
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
        URL.revokeObjectURL(elink.href); // 释放内存
      } else {
        alert("下载失败，错误码：" + oReq.status);
      }
    };
  
    oReq.onerror = function () {
      if (typeof setLoading === "function") {
        setLoading(false);
      }
      alert("网络出错了!");
    };
  
    if (method.toUpperCase() === "POST") {
      oReq.send(JSON.stringify(param));
    } else {
      oReq.send();
    }
  }
  

export default fileDownload;


// WEBPACK FOOTER //
// ./src/components/comm/download.js